import React from "react";
import PropTypes from "prop-types";
import { DynamicText } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { useEffect } from "react";
/**
 *
 * @param className
 * @param title
 * @param tag
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>|JSX.Element|null}
 * @constructor
 */
export default function Title({ className, containerClass="highlight-title", title, tag, highlight, variant, display, split, hideBr }) {
  

  useEffect(() => {
    const cards = document.querySelector(`.${containerClass}`);

    if(!cards) return;

    const observer = new ResizeObserver(() => {
      const childElements = cards.querySelectorAll('.highlight-span');

      let lastRowDivs = [];
      let prevOffset = 0;

      childElements.forEach((el, index) => {
        el.classList.remove('span_highlight');
        if (index === 0) {
          prevOffset = el.offsetTop;
          lastRowDivs = [el];
        } else {
          if (el.offsetTop - prevOffset > 5) {
              lastRowDivs = [el];
          } else {
              lastRowDivs.push(el);
          }
        }

        prevOffset = el.offsetTop;

      });

      lastRowDivs.forEach((div, index) => {
        div.classList.add('span_highlight');
        div.classList.add('span-padding');
        if (index === lastRowDivs.length - 1) {
          div.classList.remove('span-padding');
        }
      });
    });

    observer.observe(cards);
  }, []); 

  if (!title) {
    return null;
  }

  if (typeof title === "string") {
    let titleHtml = "";
    const titleArray = title.split(" ");

    if (highlight) {
      titleArray.forEach((word, index) => {
        titleHtml += "<span class='highlight-span primary'>" + word + " </span>";
      });
    } else {
      titleHtml = title;
    }

    return React.createElement(tag, {
      className: clsx(classes.title, className, containerClass, variant),
      dangerouslySetInnerHTML: { __html: display == "full" ? title : titleHtml },
    });
  }

  return (
    <DynamicText className={clsx(classes.title, className)} path={title.path} tag={tag}>
      {title.placeholder}
    </DynamicText>
  );
}

Title.defaultProps = {
  className: "",
  tag: "h2",
  title: null,
};

Title.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "div", "span"]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
